export default "__VITE_ASSET__4e8eddb4__"